import { format, isValid } from 'date-fns';

/** CPR 등 일부 폼에서 `find_time`이 `Date`·ISO 문자열·`HH:mm`·빈 문자열로 올 수 있음 */
export function coercePickerDate(value: unknown): Date | null {
  if (value == null || value === '') return null;
  if (value instanceof Date && isValid(value)) return value;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return null;
    const fromIso = new Date(trimmed);
    if (!isNaN(fromIso.getTime())) return fromIso;
    const withSeconds = /^(\d{1,2}):(\d{2}):\d{2}/.exec(trimmed);
    if (withSeconds) {
      const b = new Date();
      b.setHours(
        parseInt(withSeconds[1], 10),
        parseInt(withSeconds[2], 10),
        0,
        0
      );
      return b;
    }
    const m = /^(\d{1,2}):(\d{2})$/.exec(trimmed);
    if (m) {
      const b = new Date();
      b.setHours(parseInt(m[1], 10), parseInt(m[2], 10), 0, 0);
      return b;
    }
  }
  return null;
}

/**
 * MobileTimePicker(Date) → 커스텀 TimePicker 표시용 `HH:mm` (로컬 벽시계).
 * 기존 폼/상태가 `Date | null`일 때 UI만 바꿀 때 사용.
 */
export function dateToHHmm(input: Date | null | undefined): string {
  if (input == null || !isValid(input)) return '';
  return format(input, 'HH:mm');
}

/**
 * TimePicker `HH:mm` → `Date | null`. 캘린더 일자는 기존 `Date`가 있으면 유지, 없으면 오늘(로컬).
 * MobileTimePicker가 하던 “시간만 바꾸고 날짜는 기존 값 또는 당일”에 맞춤.
 */
export function hhmmToLocalDate(
  hhmm: string,
  existingDate: Date | null | undefined
): Date | null {
  const t = hhmm?.trim();
  if (!t) return null;
  const m = /^(\d{1,2}):(\d{2})$/.exec(t);
  if (!m) return null;
  const h = parseInt(m[1], 10);
  const min = parseInt(m[2], 10);
  if (h < 0 || h > 23 || min < 0 || min > 59) return null;
  const base =
    existingDate != null && isValid(existingDate)
      ? new Date(existingDate)
      : new Date();
  base.setHours(h, min, 0, 0);
  return base;
}
